/**
 * 퀴즈 문제별 깨구단(QueBoard) 프리셋 수식 매핑
 *
 * CSV "Curriculum Summary Oct 24" 기반 하드코딩.
 * quizId(string) → 해당 문제에서 사용할 수식(left × right) 배열.
 */

import type { Problem } from './types'

export const QUEBOARD_QUIZ_PRESETS: Record<string, Problem[]> = {
  // ── 텔레포트 (10기준): 곱하기 9, 합도 9 (깨처: 12576579475088874) ──
  '12732429441700235': [{ left: 6, right: 9 }],
  '16916731184287809': [{ left: 7, right: 9 }, { left: 7, right: 8 }],
  '16916902412554384': [{ left: 7, right: 9 }],
  '12732401818014088': [{ left: 4, right: 9 }],
  '16880841867137459': [{ left: 8, right: 9 }, { left: 3, right: 9 }],
  '12735301021601798': [{ left: 8, right: 9 }],
  '16894755078148856': [{ left: 8, right: 9 }],

  // ── 텔레포트 (10기준): 5×9 ──
  '12821822500245602': [{ left: 5, right: 9 }],

  // ── 텔레포트 (10기준): 8×8, 구구단 절대 외우지 마라 (깨처: 11744150405391536) ──
  '12735156502663301': [{ left: 9, right: 9 }, { left: 8, right: 8 }, { left: 7, right: 7 }],
  '16880971907338721': [{ left: 9, right: 9 }],
  '15062795783508778': [{ left: 8, right: 8 }],
  '13279254822683854': [{ left: 7, right: 7 }, { left: 6, right: 7 }, { left: 7, right: 4 }],
  '13279255854482639': [{ left: 7, right: 7 }],

  // ── 텔레포트 (10기준): 텔레포트를 다이어그램으로 (깨처: 12576580901152237) ──
  '12735339382706188': [{ left: 7, right: 8 }],
  '16881024629740015': [{ left: 7, right: 8 }],
  '13279252960412876': [{ left: 7, right: 8 }],

  // ── 텔레포트 (10기준): 6×8 ──
  '12809274568741801': [{ left: 6, right: 8 }],

  // ── 텔레포트 (5기준): 쉬운 타깃네모를 골라라 (깨처: 12576572218942937) ──
  '13279250536105162': [{ left: 6, right: 7 }],
  '16894779883262717': [{ left: 6, right: 7 }, { left: 7, right: 8 }],
  '14815420766753037': [{ left: 6, right: 7 }, { left: 7, right: 4 }],

  // ── 은행: 4×9 ──
  '16881557826441835': [{ left: 4, right: 9 }],
}

/**
 * 특정 quizId에 대한 QueBoard 프리셋 수식 반환.
 * 매핑이 없으면 null 반환.
 */
export function getQueBoardPresetsForQuiz(quizId: string): Problem[] | null {
  return QUEBOARD_QUIZ_PRESETS[quizId] ?? null
}
